<script setup lang="ts">
  import type { MenuItem } from '@/routes'
  import type { NestUser } from '@/types/user'
  import {
    Account,
    Logout,
    Logo,
    MenuBar,
    type Nullish,
  } from '@logistiek-zonder-papier/lzp-library'
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'

  const router = useRouter()

  const { user } = defineProps<{
    user: NestUser
    menu: MenuItem[]
  }>()

  const logo = ref<string | Nullish>()

  function logout() {
    localStorage.removeItem('jwt_token')
    router.replace('/login')
  }
</script>

<template>
  <div class="sidebar">
    <div class="logo-container">
      <img v-if="logo" class="logo" :src="logo" />
      <Logo v-else class="logo" />
    </div>
    <MenuBar class="menu-bar" :menu-config="menu" />
    <div class="account-container">
      <div class="account">
        <Account />
        <div>{{ user.firstName }} {{ user.lastName }}</div>
      </div>
    </div>
    <div class="logout" @click="logout()">
      <Logout class="logout-icon" />
      <div>Uitloggen</div>
    </div>
  </div>
</template>

<style lang="css" scoped>
  .sidebar {
    display: flex;
    flex-direction: column;
    justify-content: start;
    width: var(--spacing-xxl);
    min-height: 100%;
    overflow-y: auto;
  }

  .menu-bar {
    padding: var(--spacing-s);
  }

  .account-container {
    user-select: none;
    border-top: 1px solid var(--colours-grey-3);
    padding: var(--spacing-s);
  }

  .account {
    border-radius: var(--components-component-corners);
    padding: var(--spacing-xs) var(--spacing-s);
    display: flex;
    flex-direction: row;
    gap: var(--spacing-xs);
  }

  .logout:hover {
    cursor: pointer;
    background-color: color-mix(
      in srgb,
      var(--colours-grey-2) 20%,
      var(--colours-support-hover) 80%
    );
  }

  .logout {
    border-radius: var(--components-component-corners);
    padding: var(--spacing-xs) var(--spacing-m);
    display: flex;
    flex-direction: row;
    gap: var(--spacing-xs);
  }

  .logout-icon {
    width: 20px;
    height: 20px;
  }

  .logo-container {
    border-bottom: 1px solid var(--colours-grey-3);
    display: flex;
    padding: var(--spacing-s) var(--spacing-m);
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }

  .logo {
    height: var(--components-component-height);
  }
</style>
